import { render, staticRenderFns } from "./ActivationInfoT2.vue?vue&type=template&id=194c7277&"
import script from "./ActivationInfoT2.vue?vue&type=script&lang=js&"
export * from "./ActivationInfoT2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports